import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function NoPermission() {
  const navigate = useNavigate();

  return (
    <div className="row row-sm animation_fade">
      <div className="col-12">
        <div className="card custom-card">
          <div className="card-body text-center" style={{ padding: "60px 20px" }}>
            <div className="mb-4">
              <div
                style={{
                  width: "90px",
                  height: "90px",
                  borderRadius: "50%",
                  background: "rgba(var(--primary-rgb), 0.1)",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginBottom: "20px",
                }}
              >
                <i
                  className="fa fa-lock"
                  style={{ fontSize: "38px", color: "var(--primary-bg-color, #6259ca)" }}
                ></i>
              </div>
            </div>

            <h2 className="main-content-label mb-2" style={{ fontSize: "22px" }}>
              Access Denied
            </h2>
            <p className="text-muted mb-4" style={{ fontSize: "14px", maxWidth: "400px", margin: "0 auto 24px" }}>
              You don't have permission to access this page. Please contact your administrator if you think this is a mistake.
            </p>

            <button
              className="btn ripple btn-main-primary"
              onClick={() => navigate('/admin/dashboard')}
            >
              <i className="fa fa-home me-2"></i>
              Back to Dashboard
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
